import { mergeHead, type HeadDescriptor } from '../shared/seo/HeadDescriptor.js';
import { defaultHead } from '../shared/seo/defaultHead.js';
import type { SiteInfo } from '../shared/seo/jsonld.js';

/**
 * El `<head>` de la búsqueda, compartido por el loader y la vista.
 *
 * `noindex,follow`: cada término es una URL distinta y no hay nada que indexar ahí — las
 * notas ya tienen la suya.
 */
export function headDeBusqueda(q: string, site: SiteInfo): HeadDescriptor {
  return mergeHead(defaultHead(site, q ? `/buscar?q=${encodeURIComponent(q)}` : '/buscar'), {
    title: q ? `Buscar: ${q} — ${site.name}` : `Buscar — ${site.name}`,
    robots: 'noindex,follow',
  });
}
